import { render, staticRenderFns } from "./videogramme_table.vue?vue&type=template&id=c5a16558&scoped=true"
import script from "./videogramme_table.vue?vue&type=script&lang=js"
export * from "./videogramme_table.vue?vue&type=script&lang=js"
import style0 from "./videogramme_table.vue?vue&type=style&index=0&id=c5a16558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a16558",
  null
  
)

export default component.exports